export const tonKho = {
  title: 'Inventory stock',
  tabs: {
    list: 'Stock list',
    stats: 'CN / VN summary',
  },
  fields: {
    batchCode: 'Batch code',
    customerCode: 'Cust. code',
    customerName: 'Customer',
    productName: 'Product',
    qty: 'Qty on hand',
    unit: 'UoM',
    warehouseCode: 'Wh. code',
    warehouseName: 'Warehouse',
    weight: 'Weight',
    volume: 'Volume',
    note: 'Note',
  },
  filter: {
    searchPlaceholder: 'Search...',
    viewMode: 'View mode',
    warehouseId: 'Warehouse ID (optional)',
  },
  viewMode: {
    byBatch: 'By batch / lot',
    byCustomer: 'By customer',
  },
  actions: {
    exportExcel: 'Export Excel',
  },
  stats: {
    overview: 'Overview',
    vn: 'Vietnam',
    tq: 'China',
    other: 'Other',
    metrics: {
      tongSoLo: 'Total batches',
      tongSoKien: 'Total cartons',
      tongTrongLuong: 'Total weight (kg)',
      tongTheTich: 'Total volume (cm³)',
      soLo: 'Batches',
      soKien: 'Cartons',
      trongLuong: 'Weight (kg)',
      theTich: 'Volume (cm³)',
    },
  },
  messages: {
    noData: 'No data',
    noStats: 'No statistics available',
  },
}
